import './HvacResultSavingsCard.scss';
import React, { memo, ReactNode } from 'react';

type Props = {
  icon: ReactNode;
  title: ReactNode;
  label: ReactNode;
  value: ReactNode;
  firstDetailLabel?: ReactNode;
  firstDetailValue?: ReactNode;
  secondDetailLabel: ReactNode;
  secondDetailValue: ReactNode;
  headerPostfix?: ReactNode;
};

export const HvacResultSavingsCard = memo(({
  icon,
  title,
  label,
  value,
  headerPostfix,
  firstDetailLabel,
  firstDetailValue,
  secondDetailLabel,
  secondDetailValue,
}: Props) => (
  <div className="bp-hvac-result-savings-card">
    <div className="bp-hvac-result-savings-card__header">
      <div className="bp-hvac-result-savings-card__icon">
        {icon}
      </div>

      <div className="bp-hvac-result-savings-card__title">
        {title}
      </div>
      {headerPostfix}
    </div>

    <div className="bp-hvac-result-savings-card__body">
      <div className="bp-hvac-result-savings-card__label">
        {label}
      </div>

      <div className="bp-hvac-result-savings-card__value-wrapper">
        <div className="bp-hvac-result-savings-card__value">
          {value}
        </div>
      </div>
    </div>
  </div>
));
